// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"bf1dd04c","583":"b64bd696","983":"c8172ad9"}[chunkId] + ".chunk.js";
};